import { useEffect } from 'react';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { ToastProvider } from './hooks/useToast';
import { ThemeProvider } from './contexts/ThemeContext';
import { Router, navigate } from './components/Router';
import FeedPage from './components/FeedPage';
import TagPage from './components/TagPage';
import ColorPage from './components/ColorPage';
import Login from './components/Login';
import CardDetailPage from './components/CardDetailPage';
import ErrorPage from './components/ErrorPage';
import AboutPage from './components/AboutPage';

function LogoutHandler() {
  const { logout } = useAuth();
  useEffect(() => {
    logout();
  }, []);
  return null;
}

function AppContent() {
  const { currentUser, loading } = useAuth();

  return (
    <>
      <Router>
        {(route, params) => {
        switch (route) {
          case 'logout':
            return <LogoutHandler />;
          case 'login':
            if (currentUser && !loading) {
              navigate('/');
              return null;
            }
            return <Login onSuccess={() => {
              navigate('/');
            }} />;
          case 'card_detail':
            return <CardDetailPage cardId={params.cardId} />;
          case 'tag':
            return <TagPage tagName={params.tagName} />;
          case 'color':
            return <ColorPage colorName={params.colorName} />;
          case 'about':
            return <AboutPage />;
          case '404':
            return <ErrorPage type="404" />;
          case '403':
            return <ErrorPage type="403" />;
          case 'home':
            return <FeedPage initialMonth={params.month} />;
          default:
            return <ErrorPage type="404" />;
        }
        }}
      </Router>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <AppContent />
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
